import './index.scss'

import React from 'react'
import T from 'prop-types'
import BEMHelper from 'react-bem-helper'

const bem = new BEMHelper('confirmation-header')

export default function ConfirmationHeader({ title }) {
  return (
    <header {...bem('')}>
      <svg width="83" height="60" viewBox="0 0 83 60" {...bem('illustration')}>
        <path d="M2.24195 15.3343C4.7941 12.9098 8.82851 13.0132 11.2531 15.5654L34.5624 41.3152L71.3717 2.06538C73.7962 -0.486766 77.8306 -0.590213 80.3828 1.83433C82.9349 4.25887 83.0383 8.29328 80.6138 10.8454L34.5624 59.8239L2.0109 24.3454C-0.413647 21.7933 -0.310202 17.7589 2.24195 15.3343Z" />
      </svg>

      <h1 {...bem('title')}>{title}</h1>
    </header>
  )
}

ConfirmationHeader.propTypes = {
  title: T.string.isRequired,
}
